// Avisos DO JOGO: placa de metal com brasa, nada do padrão de notificação do site.
// Uso: gbAviso.ok('...'), gbAviso.erro('...'), gbAviso.info('...')
import React, { useEffect, useState } from 'react';
import { CheckCircle2, Info, XCircle } from 'lucide-react';

let ouvintes = [];
let seq = 0;

const soltar = (tipo, texto, ms) => {
  const aviso = { id: ++seq, tipo, texto: String(texto || ''), ms: ms || 3400 };
  ouvintes.forEach((f) => f(aviso));
  return aviso.id;
};

export const gbAviso = {
  ok: (t, ms) => soltar('ok', t, ms),
  erro: (t, ms) => soltar('erro', t, ms),
  info: (t, ms) => soltar('info', t, ms),
};

const ESTILO = {
  ok: { borda: 'border-emerald-400/60', brilho: 'rgba(16,185,129,.45)', cor: 'text-emerald-200', Icon: CheckCircle2 },
  erro: { borda: 'border-rose-500/60', brilho: 'rgba(244,63,94,.45)', cor: 'text-rose-200', Icon: XCircle },
  info: { borda: 'border-amber-400/60', brilho: 'rgba(245,158,11,.45)', cor: 'text-amber-200', Icon: Info },
};

export const GbNotices = () => {
  const [itens, setItens] = useState([]);

  useEffect(() => {
    const aoReceber = (a) => {
      setItens((x) => [...x.slice(-2), a]);
      setTimeout(() => setItens((x) => x.filter((i) => i.id !== a.id)), a.ms);
    };
    ouvintes.push(aoReceber);
    return () => { ouvintes = ouvintes.filter((f) => f !== aoReceber); };
  }, []);

  if (!itens.length) return null;
  return (
    <div className="pwa-safe-top pointer-events-none fixed inset-x-0 top-[70px] z-[96] flex flex-col items-center gap-2 px-3"
      data-testid="gb-notices">
      {itens.map((a) => {
        const e = ESTILO[a.tipo] || ESTILO.info;
        return (
          <div key={a.id} data-testid={`gb-notice-${a.tipo}`}
            className={`gb-aviso flex w-full max-w-sm items-center gap-2.5 rounded-2xl border ${e.borda} bg-[linear-gradient(100deg,rgba(18,8,32,.97),rgba(8,4,14,.97))] px-3.5 py-2.5 backdrop-blur-xl`}
            style={{ boxShadow: `0 10px 30px rgba(0,0,0,.7), 0 0 22px ${e.brilho}` }}>
            <e.Icon className={`h-4 w-4 shrink-0 ${e.cor}`} />
            <span className={`text-xs font-black leading-snug ${e.cor}`}>{a.texto}</span>
          </div>
        );
      })}
    </div>
  );
};

export default GbNotices;
